import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest, postRequest} from "../../api";

export const handleLoadRequests = createAsyncThunk('direct/handleLoadRequests', async(page) => {
    try{
        const {data} = await getRequest(`/member/program/request/${page}?status=rejected&status=accepted&status=pending`)
        return data
    }
    catch(err) {
        console.log(err.response.data.message)
    }
})

export const handleLoadSentRequests = createAsyncThunk('direct/handleLoadSentRequests', async(page) => {
    try{
        const {data} = await getRequest(`/member/program/request/${page}`, { status: 'sent' })
        return data
    }
    catch(err) {
        console.log(err.response.data.message)
    }
})

export const handleRejectRequest = createAsyncThunk('direct/handleRejectRequest', async(allData) => {
    const {body, dispatch, router} = allData
    try{
        const {data} = await postRequest('/member/program/request/status', body)
        if(data.is_successful){
            setTimeout(() => {
                dispatch(setRejectedFlag(false))
                router.push('/direct')
            }, 1500);
        }
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleAcceptRequest = createAsyncThunk('direct/handleAcceptRequest', async(allData) => {
    const {body, dispatch, router} = allData
    try{
        const {data} = await postRequest('/member/program/request/status', body)
        if(data.is_successful){
            dispatch(setAcceptedFlag(true))
            setTimeout(() => {
                dispatch(setAcceptingFlag(false))
                router.push(`${router.location.pathname}/confirm-request`);
            }, 2000);
        }
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleInformation = createAsyncThunk('direct/handleInformation', async(memberPk) => {
    try{
        const {data} = await getRequest(`/member/general-info?member_pk=${memberPk}`)
        return data
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

const directSlice = createSlice({
    name: 'direct',
    initialState: {
        requests: [],
        sentRequests: [],
        directRequestData: null,
        flags: {
            acceptedFlag: false,
            acceptingFlag: false,
            rejectedFlag: false,
        },
        information: {},
    },
    reducers: {
        setDirectRequestData: (state, action) => {
            state.directRequestData = action?.payload
        },
        setRejectedFlag: (state, action) => {
            state.flags.rejectedFlag = action?.payload
        },
        setAcceptingFlag: (state, action) => {
            state.flags.acceptingFlag = action?.payload
        },
        setAcceptedFlag: (state, action) => {
            state.flags.acceptedFlag = action?.payload
        },
    },
    extraReducers(builder){
        builder
            .addCase(handleLoadRequests.fulfilled, (state, action) => {
                state.requests = action?.payload
            });
        builder
            .addCase(handleLoadSentRequests.fulfilled, (state, action) => {
                state.sentRequests = action?.payload
            });
        builder
            .addCase(handleRejectRequest.pending, (state) => {
                state.flags.rejectedFlag = true
            })
            .addCase(handleRejectRequest.rejected, (state, action) => {
                state.flags.rejectedFlag = false
                alert('خطایی رخ داد لطفا دوباره تلاش کنید')
            })
        builder
            .addCase(handleAcceptRequest.pending, (state, action) => {
                state.flags.acceptingFlag = true
            })
            .addCase(handleAcceptRequest.rejected, (state, action) => {
                state.flags.acceptingFlag = false
                alert('خطایی رخ داد لطفا دوباره تلاش کنید')
            })
        builder
            .addCase(handleInformation.fulfilled, (state, action) => {
                console.log(action?.payload)
                state.information = action?.payload
            })
    }
})

export const {setDirectRequestData, setRejectedFlag, setAcceptedFlag, setAcceptingFlag} = directSlice.actions
export const selectRequests = state => state.direct.requests
export const selectSentRequests = state => state.direct.sentRequests
export const selectDirectRequestData = state => state.direct.directRequestData
export const selectAcceptedFlag = state => state.direct.flags.acceptedFlag
export const selectAcceptingFlag = state => state.direct.flags.acceptingFlag
export const selectRejectedFlag = state => state.direct.flags.rejectedFlag
export const selectInformation = state => state.direct.information

export default directSlice.reducer